module.exports = __webpack_public_path__ + "static/media/IMG_7865_cropped.d63ec317.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/IMG_7865_cropped.png
// module id = 42
// module chunks = 0